import React, { Component } from 'react';

/**
 * This is a static react port of the cdc template linkedin logo svg
 */

export default class LinkedInLogo extends Component {

    render() {
        return (
            <svg width="25" height="24" viewBox="0 0 448 512" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100.28 448H7.4V148.9H100.28V448ZM53.79 108.1C24.09 108.1 0 83.5 0 53.8C2.1258e-07 39.534 5.66714 25.8523 15.7547 15.7647C25.8423 5.67715 39.524 0.0100098 53.79 0.0100098C68.056 0.0100098 81.7377 5.67715 91.8253 15.7647C101.913 25.8523 107.58 39.534 107.58 53.8C107.58 83.5 83.48 108.1 53.79 108.1ZM447.9 448H355.22V302.4C355.22 267.7 354.52 223.2 306.93 223.2C258.64 223.2 251.24 260.9 251.24 299.9V448H158.46V148.9H247.54V189.7H248.84C261.24 166.2 291.53 141.4 336.72 141.4C430.72 141.4 448 203.3 448 283.7V448H447.9Z" fill="white" />
            </svg>
        );
    }

}
